export const deriveTitleAndSubmitLabel = (
    isEditMode: boolean,
): { title: string; submitLabel: string } => {
    return isEditMode
        ? {
              title: "Ingeplande kwalificatie bewerken",
              submitLabel: "Wijzigingen opslaan",
          }
        : {
              title: "Kwalificatie inplannen",
              submitLabel: "Ingeplande kwalificatie toevoegen",
          };
};
